import {
  PostGetClassListResponse,
  PostGetClassMsgResponse,
} from "@/openapi/baob/pc.MsgManager";

export type NoticeItemType = PostGetClassListResponse["list"][0];
export type NoticeTabType = PostGetClassMsgResponse[number];

/**
 * 消息读取状态
 */
export enum ReadStatus {
  /**
   * 全部
   */
  ALL = "0",
  /**
   * 已读
   */
  READ = "1",
  /**
   * 未读
   */
  UNREAD = "2",
}

/**
 * 消息读取状态
 */
export enum JumpStatus {
  /**
   * 可以跳转
   */
  JUMP = "1",
  /**
   * 不可以跳转
   */
  NO_JUMP = "2",
}
